import { useJobHealthApi } from "../api/JobHealthApiClient";
import { JobHealthFrontendService } from "../services/JobHealthFrontendService";

export const useJobHealthService = (): JobHealthFrontendService =>
  new JobHealthFrontendService(useJobHealthApi());
